<template>
  <div>

    <div class="search-condition no_margin">
      <div>
        <span class="name">当前油站：</span>
        <span>{{currentGasStation}}</span>
        <el-tooltip class="item" effect="light" content="温馨提示：若油站有清洁燃料，则在油价管理、油枪管理、营销活动页及非团油页，仅显示普通油品/油号，不显示清洁燃料油品/油号" placement="right">
          <i class="el-icon-question" style="margin-top: 7px;"></i>
        </el-tooltip>
        <!-- <el-select v-model="oisName" placeholder="请选择油站" style="width: 650px">
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.gasName"
            :value="item.gasId">
          </el-option>
        </el-select> -->
      </div>
      <!-- <el-button type="primary" size="medium" @click="refresh">查询</el-button> -->
    </div>
    <el-card shadow="never" v-if="oilCycleList.length !== 0">
       <div class="oil_set"><img class="img" src="https://web.nlktj.com/ty/merchant/laba.png" alt=""><span v-for="(item, index) in oilCycleList" :key="index">{{item}}号 <span v-if="index < oilCycleList.length - 1">、</span></span>油已设置周期改价，如需更改，请联系您的业务经理</div>
    </el-card>
    <div class="table-wrap">
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange"
        :hasIndex="true"
        :border="false">
        <template slot="effectiveTime" slot-scope="{row}">
          <span v-show="row.status === 1">{{ row.effectiveTime ? row.effectiveTime : '已生效' }}</span>
        </template>
        <template slot="handler" slot-scope="{row}">
          <div>
            <el-button v-show="row.status === 1" class="table-mini-btn" @click="modifyPrice(row)">修改</el-button>
            <el-button class="table-mini-btn" @click="changeRecord(row)">变更记录</el-button>
          </div>
        </template>
      </mer-table>
    </div>

    <!-- 变更记录 -->
    <el-dialog :visible.sync="changeRecordVisible" @close="recordClose('recordBack')" center>
      <div slot="title" class="dialog-title">油价变更记录</div>
      <el-table :data="changeRecordData" stripe style="width: 100%" size="small" v-loading="recordTableLoading">
        <el-table-column property="createUser" label="操作人" align="center"></el-table-column>
        <el-table-column property="createDt" label="操作时间" align="center"></el-table-column>
        <el-table-column property="operate" label="操作类型" align="center" width="100"></el-table-column>
        <el-table-column property="operateRecord" label="操作记录" align="center" width="250">
          <template slot-scope="{row}">
            <!-- <div>
              {{ `枪价：由${row.beforePriceGun}元 改为：${row.afterPriceGun}元` }}
            </div> -->
            <span>{{ row.record }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeRecordVisible = false">返回</el-button>
      </span>
    </el-dialog>

    <!-- 修改油价 -->
    <el-dialog :visible.sync="modifyOilGunVisible" @close="recordClose('cancelUpdate')" center width="800px">
      <div slot="title" class="dialog-title">修改油价</div>
      <el-form :model="modifyData" label-width="140px" :inline="true" :rules="formRules" ref="form">
        <el-form-item label="油号：">
          <el-input v-model="modifyData.oilNum" disabled></el-input>
        </el-form-item>
        <el-form-item label="单位：">
          <el-input v-model="modifyData.unitName" disabled></el-input>
        </el-form-item>
        <!-- 船舶显示表单 -->
        <template v-if="isShipStation">
          <el-form-item label="枪价：">
            <el-input v-model="modifyData.priceGun" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="周期价">
            <el-input v-model="modifyData.priceGun" disabled></el-input>
            <span style="color: red;">如需求修改周期价，去请联系您的业务经理</span>
          </el-form-item> -->
          <el-form-item label="当前无票枪价：">
            <el-input v-model="modifyData.priceGunNoInvoice" disabled></el-input>
          </el-form-item>
          <el-form-item label="调整后枪价：" prop="modifyPrice">
            <el-input-number v-model="modifyData.modifyPrice" :precision="2" :max="9000"></el-input-number>
          </el-form-item>
          <el-form-item label="调整后无票枪价：" prop="updatePriceGunNoInvoice">
            <el-input-number v-model="modifyData.updatePriceGunNoInvoice" :precision="2" :max="9000"></el-input-number>
          </el-form-item>
        </template>
        <!-- 油站显示表单 -->
        <template v-else>
          <el-form-item label="国际价：">
            <el-input v-model="modifyData.priceOfficial" disabled></el-input>
          </el-form-item>
          <el-form-item label="枪价：">
            <el-input v-model="gunMoney" disabled></el-input>
          </el-form-item>
          <el-form-item label="周期价：" v-if="cycleMoney">
            <el-input v-model="cycleMoney" disabled></el-input>
            <span style="color: red;">*如需修改周期价，请联系您的业务经理</span>
          </el-form-item>
          <el-form-item label="调整后枪价：">
            <el-input-number v-model="gunMoneyCopy" :precision="2" :max="9000"></el-input-number>
          </el-form-item>
          <!-- 金盾权限展示 -->
          <template v-if="hasGoldenRight">
            <el-form-item :label="`${platformName}价（商用车）`" prop="merchantPrice">
              <el-input v-model="modifyData.merchantPrice"></el-input>
            </el-form-item>
            <el-form-item :label="`${platformName}价（私家车）`" prop="noMerchantPrice">
              <el-input v-model="modifyData.noMerchantPrice"></el-input>
            </el-form-item>
            <el-form-item label="指定人群" prop="openTargetPrice">
              <el-switch v-model="modifyData.openTargetPrice" @change="peopleChange"></el-switch>
            </el-form-item>
          </template>
          <template v-if="modifyData.openTargetPrice">
            <div v-for="(item, index) in modifyData.targetPriceDtoList" :key="index" class="appoint_box">
              <span class="record labelSpan">近</span>
              <el-form-item label="" :label-width="peopleLabel" :prop="`targetPriceDtoList[${index}].activeDays`" :rules="formRules.peoleSelect"  style="width: 100px">
                <el-select v-model="item.activeDays" placeholder="请选择" size="small">
                  <el-option
                    v-for="(i) in daysOption"
                    :key="i.code"
                    :label="i.desc"
                    :value="i.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <span class="labelSpan">交易</span>
              <el-form-item label="" :label-width="peopleLabel" :prop="`targetPriceDtoList[${index}].dealCount`" :rules="formRules.peoleSelect"  style="width: 140px">
                <el-select v-model="item.dealCount" placeholder="请选择" size="small">
                  <el-option
                    v-for="(i) in ordersOption"
                    :key="i.code"
                    :label="i.desc"
                    :value="i.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <span class="labelSpan">单，商用车：</span>
              <el-form-item label="" :label-width="peopleLabel" :prop="`targetPriceDtoList[${index}].merchantPrice`" :rules="formRules.peoleInput"  style="width: 120px">
                <el-input-number :precision="2" :min="2" :max="modifyData.modifyPrice" v-model="item.merchantPrice" :placeholder="`${platformName}价`" size="small"></el-input-number>
              </el-form-item>
              <span class="labelSpan">非商用车：</span>
              <el-form-item label="" :label-width="peopleLabel" :prop="`targetPriceDtoList[${index}].noMerchantPrice`" :rules="formRules.peoleInput"  style="width: 120px">
                <el-input-number :precision="2" :min="2" :max="modifyData.modifyPrice" v-model="item.noMerchantPrice" :placeholder="`${platformName}价`" size="small"></el-input-number>
              </el-form-item>
              <div class="btn_box">
                <el-button v-if="index === modifyData.targetPriceDtoList.length- 1 && index < 8" @click="addPeople" icon="el-icon-plus" circle></el-button>
                <el-button v-if="modifyData.targetPriceDtoList.length!==1" @click="delePeople(index)" type="danger" icon="el-icon-delete" circle></el-button>
              </div>
            </div>
          </template>
        </template>
        <el-form-item label="生效时间：" prop="entryIntoForceTime">
          <el-radio :label="0" v-model="timeType">立即</el-radio>
          <el-radio :label="1" v-model="timeType">指定日期</el-radio>
          <!-- <div> -->
            <el-date-picker
              v-model="modifyData.entryIntoForceTime"
              align="right"
              type="datetime"
              :disabled="!Boolean(timeType)"
              placeholder="选择日期"
              :pickerOptions="pickerOptions">
            </el-date-picker>
          <!-- </div> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyOilGunVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submit">提交</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import { getGasPriceList, updateOilPrice, checkLog, getAllGasInfoList, getOption, inCyclePriceTaskOilNos, getOilPriceDetail } from '@/api/gasStationManage/gasInfo'
import { getGoldenRight } from '@/api/common'
import dayjs from 'dayjs'
import { mapState, mapGetters } from 'vuex'
import { selectOption, openTargetPriceConfig } from './config'
// 埋点数据
let mdObj = {
  pageview: {
    type: 'pageViewEvent',
    name: '油价管理',
    id: '1621476532'
  },
  update: {
    type: 'clickEvent',
    name: '油价管理修改',
    id: '1621476534'
  },
  changeRecord: {
    type: 'clickEvent',
    name: '油价管理变更记录',
    id: '1621476535'
  },
  recordBack: {
    type: 'clickEvent',
    name: '油价管理变更记录返回',
    id: '1621476536'
  },
  entryTime: {
    type: 'clickEvent',
    name: '油价管理修改生效时间',
    id: '1621476537'
  },
  gunPrice: {
    type: 'clickEvent',
    name: '油价管理修改调整后枪价',
    id: '1621476538'
  },
  submitUpdate: {
    type: 'clickEvent',
    name: '油价管理修改油价提交',
    id: '1621476539'
  },
  cancelUpdate: {
    type: 'clickEvent',
    name: '油价管理修改油价取消',
    id: '1621476584'
  }
}

const TABLECONFIG = [
  // {label: '油站编码', prop: 'gasId', width: '60'},
  // {label: '油站名称', prop: 'gasName'},
  {label: '油号', prop: 'oilNum', width: 30},
  {label: '单位', prop: 'unitName', width: 30},
  {label: '国标价', prop: 'priceOfficial', width: 30},
  {label: '枪价', prop: 'priceGun', width: 30},
  {label: '当前枪价', prop: 'priceGun', width: 50},
  {label: '变更后枪价', prop: 'updateGunPrice', width: 50},
  {label: '生效时间', prop: 'effectiveTime',slot: 'effectiveTime', width: 80},
  {label: '状态', prop: 'statusName', width: 30},
  {label: '操作项', prop: 'tradingTime', slot: 'handler', width: 80}
]

// const isSdLogin = JSON.parse(sessionStorage.getItem('isSdLogin'))
// 金盾权限额外字段
// const TABLE_ELSE = [
//   {label: `${isSdLogin?'顺达':'团油'}价(商用车)`, prop: 'merchantPrice', width: 50},
//   {label: `${isSdLogin?'顺达':'团油'}价(私家车)`, prop: 'noMerchantPrice', width: 50}
// ]

const SHIPTABLECONFIG = [
  {label: '油号', prop: 'oilNum', width: 30},
  {label: '单位', prop: 'unitName', width: 30},
  {label: '国标价', prop: 'priceOfficial', width: 30},
  {label: '当前枪价', prop: 'priceGun', width: 50},
  {label: '当前无票枪价', prop: 'priceGunNoInvoice', width: 50},
  {label: '变更后枪价', prop: 'updateGunPrice', width: 50},
  {label: '变更后无票枪价', prop: 'updatePriceGunNoInvoice', width: 50},
  {label: '生效时间', prop: 'effectiveTime',slot: 'effectiveTime', width: 80},
  {label: '状态', prop: 'statusName', width: 30},
  {label: '操作项', prop: 'tradingTime', slot: 'handler', width: 80}
]

export default {
  name: 'gasStationManage_oilPriceManage',
  mixins: [listPage],
  data () {
    let checkTime = (rule, value, callback) => {
      if (this.timeType === 1) {
        if(!value){
          callback(new Error('请选择时间'))
        }
        callback() 
      }else{
        callback()
      }
    }
    return {
      oilCycleList: [], // 周期油价列表
      ...selectOption,
      peopleLabel:'0',
      options: [],
      oisName: '',
      tableConfig: [],
      tableLoading: false,
      recordTableLoading: false,
      tableData: {
        total: 0,
        records: []
      },
      pagination: { pageIndex: 1, pageSize: 10 },
      changeRecordVisible: false,
      modifyOilGunVisible: false,
      changeRecordData: [],
      statusList: ['关闭', '开启'],
      modifyData: {
        oilNo: '',
        unitName: '',
        priceOfficial: '',
        // priceGun: '',
        entryIntoForceTime: '',
        modifyPrice: '',
        merchantPrice: '',
        noMerchantPrice: '',
        updatePriceGunNoInvoice: '',
        priceGunNoInvoice: '',
        openTargetPrice: false,
        targetPriceDtoList:[],
      },
      gunMoney: '', // 枪价
      gunMoneyCopy: '', // 调整枪价
      cycleMoney: '', // 周期价
      timeType: 0,
      formRules: {
        modifyPrice: [
          { required: true, message: '请输入枪价', trigger: 'blur' }
        ],
        entryIntoForceTime:[
          { validator:checkTime, trigger: 'blur' }
        ],
        merchantPrice: [
          { required: true, message: `请输入团油价（商用车）`, trigger: 'blur' }
        ],
        noMerchantPrice: [
          { required: true, message: `请输入团油价（私家车）`, trigger: 'blur' }
        ],
        priceGunNoInvoice: [
          { required: true, message: '请输入无票枪价', trigger: 'blur' }
        ],
        updatePriceGunNoInvoice: [
          { required: true, message: '请输入调整后无票枪价', trigger: 'blur' }
        ],
        peoleSelect: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        peoleInput: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      currentGasStation:'',
      submitLoading: false,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < (Date.now()-24*60*60*1000)
        }
      },
      hasGoldenRight: false, // 是否有金盾权限
      gasId: '',
      pontoonGasIds: [], // 船舶ID的list
      isShipStation: false, // 是否为船舶加油
      closeType: 1,
      oldModifyPrice: '',
      oldTime: '',
      // isSdLogin,
      TABLE_ELSE: []
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters(['platformName'])
  },
  methods: {
    maidian (obj) {
      const { type, name, id, other = {} } = obj
      this.$track[type](name, id, other)
    },
    addPeople() {
      this.modifyData.targetPriceDtoList.push({...openTargetPriceConfig})
    },
    delePeople(index) {
      this.modifyData.targetPriceDtoList.splice(index,1)
    },
    peopleChange (val) {
      if (val && !this.modifyData.targetPriceDtoList.length) {
        this.addPeople()
      }
    },
    async getOilPriceDetail (row) {
      try {
        const { code, result } = await getOilPriceDetail({ oilNo: row.oilNo })
        if (code !== 200) return
        this.gunMoney = result.basePriceGun
        this.gunMoneyCopy = result.basePriceGun
        this.cycleMoney = result.cyclePrice
      } catch (error) {
        console.log(error)
      }
    },
    async refresh () {
      this.tableLoading = true
      try {
        const { code, result = [], totalRow } = await getGasPriceList(this.pagination)
        if (code !== 200) return
        this.tableData.records = result
        this.tableData.total = totalRow
      } catch (err) {
        console.log(err)
      } finally {
        this.tableLoading = false
      }
    },
    // 初始化油站名称下拉框
    async initSelectOptions () {
      try {
        const { code, result = [] } = await getAllGasInfoList()
        if (code !== 200) return
        this.currentGasStation = result.length ? result[0].gasName : ''
        this.gasId = result.length ? result[0].gasId : ''
        this.whetherHasShip()
      } catch (err) {
        console.log(err)
      }
    },
    async getOption () {
      try {
        const { code } = await getOption()
        if (code !== 200) return
      } catch (error) {
        console.log(error)
      }
    },
    // 判断查询油站是否是船舶油站
    whetherHasShip () {
      this.isShipStation = this.pontoonGasIds.includes(this.gasId)
      this.tableConfig = this.isShipStation ? SHIPTABLECONFIG : TABLECONFIG
    },
    submit () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          let time = dayjs(this.modifyData.entryIntoForceTime).format('YYYY-MM-DD HH:mm:ss')
          this.submitLoading = true
          let params = {
            id: this.modifyData.id,
            gasId: this.modifyData.gasId,
            // priceGun: this.modifyData.modifyPrice,
            oilNo: this.modifyData.oilNo,
            effctiveTime: !this.timeType ? '' : time,
            merchantPrice: this.modifyData.merchantPrice,
            noMerchantPrice: this.modifyData.noMerchantPrice,
            openTargetPrice: Number(this.modifyData.openTargetPrice),
            targetPrices: this.modifyData.targetPriceDtoList
          }
          params.priceGun = this.gunMoneyCopy
          // if (this.modifyData.openTargetPrice) return
          // 船舶参数需要增加 updatePriceGunNoInvoice
          if(this.isShipStation) params.priceGunNoInvoice = this.modifyData.updatePriceGunNoInvoice
          
          try {
            const {code, result} = await updateOilPrice(params)
            if (code !== 200) return
            if (result) {
              mdObj.entryTime.other = {
                tysj_date_type: this.timeType + 1
              }
              if (this.timeType === 0 || this.oldTime !== time) this.maidian(mdObj.entryTime)
              if (this.oldModifyPrice !== this.modifyData.modifyPrice) this.maidian(mdObj.gunPrice)
              this.maidian(mdObj.submitUpdate)
              this.$message.success('修改成功')
              this.modifyOilGunVisible = false
              this.refresh() 
            } else {
              this.$message.error('修改失败')
            }
          } catch (err) {
            console.log(err)
          } finally{
            this.closeType = 0
            this.submitLoading = false
          }
        }
      })
    },
    // 修改
    modifyPrice (row) {
    this.getOilPriceDetail(row)
    this.maidian(mdObj.update)
      this.timeType = 0
      let newData = JSON.parse(JSON.stringify(row))
      const { targetPriceList = [{ ...openTargetPriceConfig }], openTargetPrice, effectiveTime, priceGun } = newData
      this.modifyData = {...this.modifyData, ...newData}
      this.modifyData.entryIntoForceTime = ''
      this.modifyOilGunVisible = true
      this.modifyData.updatePriceGunNoInvoice = ''
      this.modifyData.modifyPrice = priceGun
      this.oldModifyPrice = priceGun
      this.oldTime = effectiveTime
      this.modifyData.targetPriceDtoList = targetPriceList
      this.modifyData.openTargetPrice = Boolean(openTargetPrice)
    },
    // 变更记录
    async changeRecord (row) {
    this.maidian(mdObj.changeRecord)
      this.changeRecordVisible = true
      this.recordTableLoading = true
      try {
        const {code, result} = await checkLog({gasId: row.gasId, oilNo: row.oilNo})
        if (code !== 200) return
        this.changeRecordData = result
      } catch (err) {
        console.log(err)
      } finally {
        this.recordTableLoading = false
      }
    },
    // 关闭变更记录
    recordClose (type) {
      if (this.closeType) this.maidian(mdObj[type])
      this.closeType = 1
    },
    async getGoldenRight () {
      try {
        const { code, result } = await getGoldenRight()
        if (code !== 200) return
        this.hasGoldenRight = result
        if (result) {
          const index = this.tableConfig.findIndex(item => item.prop === 'updateGunPrice')
          this.tableConfig.splice(index, 0, ...this.TABLE_ELSE)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 周期改价油号列表
    async inCyclePriceTaskOilNos () {
      try {
        const { code, result } = await inCyclePriceTaskOilNos()
        if (code !== 200) return
        this.oilCycleList = result
      } catch (error) {
        console.log(error)
      }
    }
  },
  created () {
    this.TABLE_ELSE = [...[{label: `${this.platformName}价(商用车)`, prop: 'merchantPrice', width: 50}, {label: `${this.platformName}价(私家车)`, prop: 'noMerchantPrice', width: 50}]]
    this.formRules.merchantPrice[0].message = `请输入${this.platformName}价（商用车）`
    this.formRules.noMerchantPrice[0].message = `请输入${this.platformName}价（私家车）`
    this.maidian(mdObj.pageview)
    this.pontoonGasIds = this.userInfo.pontoonGasIds || []
    this.refresh()
    this.initSelectOptions()
    this.getGoldenRight()
    this.inCyclePriceTaskOilNos()
  }
}
</script>
<style lang="less" scoped>
  @import url('../mixin.less');
  .no_margin{
    margin-bottom: 0;
  }
  .oil_set{
    color: #FC7E24;
    font-size: 14px;
    display: flex;
    align-items: center;
    .img{
      display: block;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
</style>